import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Drawer,
  List,
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core';
import {
  Dashboard as DashboardIcon,
  MenuBook as MenuBookIcon,
  People as PeopleIcon,
  DateRange as DateRangeIcon,
  Warning as WarningIcon,
  AccountCircle as UserIcon,
  Assignment,
  LibraryBooks,
  AccountTree
} from '@material-ui/icons';

import { buttonNames } from '../../constants';

const drawerWidth = 340;
const useStyles = makeStyles((theme) => ({
  dashboardContainer: {
    marginTop: 85
  },
  root: {
    display: 'flex'
  },
  appBar: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth,
    top: 65
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3)
  },
  listItem: {
    height: '85px !important'
  },
  selectedRecordItem: {
    background: '#f5f5f5',
    borderLeft: `5px solid ${theme.palette.secondary.minor}`
  }
}));

const BranchRecordsItemsList = (props) => {
  const classes = useStyles();
  const { setCurrentBranchesRecord, currentBranchesRecord } = props;

  const handleListItemClick = (recordType) => {
    setCurrentBranchesRecord(recordType);
  };

  return (
    <React.Fragment>
      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper
        }}
        anchor="left"
      >
        <List>
          <ListItem
            button
            className={
              (`${classes.listItem}`,
              currentBranchesRecord === buttonNames.DASHBOARD
                ? `${classes.selectedRecordItem}`
                : null)
            }
            onClick={() => handleListItemClick(buttonNames.DASHBOARD)}
          >
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary={buttonNames.DASHBOARD} />
          </ListItem>
          <ListItem
            button
            className={
              (`${classes.listItem}`,
              currentBranchesRecord === buttonNames.COURSES
                ? `${classes.selectedRecordItem}`
                : null)
            }
            onClick={() => handleListItemClick(buttonNames.COURSES)}
          >
            <ListItemIcon>
              <MenuBookIcon />
            </ListItemIcon>
            <ListItemText primary={buttonNames.COURSES} />
          </ListItem>
          <ListItem
            button
            className={
              (`${classes.listItem}`,
              currentBranchesRecord === buttonNames.PERSONNEL
                ? `${classes.selectedRecordItem}`
                : null)
            }
            onClick={() => handleListItemClick(buttonNames.PERSONNEL)}
          >
            <ListItemIcon>
              <PeopleIcon />
            </ListItemIcon>
            <ListItemText primary={buttonNames.PERSONNEL} />
          </ListItem>
          <ListItem
            button
            className={
              (`${classes.listItem}`,
              currentBranchesRecord === buttonNames.EVENTS
                ? `${classes.selectedRecordItem}`
                : null)
            }
            onClick={() => handleListItemClick(buttonNames.EVENTS)}
          >
            <ListItemIcon>
              <DateRangeIcon />
            </ListItemIcon>
            <ListItemText primary={buttonNames.EVENTS} />
          </ListItem>

          <ListItem
            button
            className={
              (`${classes.listItem}`,
              currentBranchesRecord === buttonNames.ACCIDENTS
                ? `${classes.selectedRecordItem}`
                : null)
            }
            onClick={() => handleListItemClick(buttonNames.ACCIDENTS)}
          >
            <ListItemIcon>
              <WarningIcon />
            </ListItemIcon>
            <ListItemText primary={buttonNames.ACCIDENTS} />
          </ListItem>

          <ListItem
            button
            className={
              (`${classes.listItem}`,
              currentBranchesRecord === buttonNames.HAZARDS
                ? `${classes.selectedRecordItem}`
                : null)
            }
            onClick={() => handleListItemClick(buttonNames.HAZARDS)}
          >
            <ListItemIcon>
              <Assignment />
            </ListItemIcon>
            <ListItemText primary={buttonNames.HAZARDS} />
          </ListItem>

          <ListItem
            button
            className={
              (`${classes.listItem}`,
              currentBranchesRecord === buttonNames.DOCUMENT_LIBRARY
                ? `${classes.selectedRecordItem}`
                : null)
            }
            onClick={() => handleListItemClick(buttonNames.DOCUMENT_LIBRARY)}
          >
            <ListItemIcon>
              <LibraryBooks />
            </ListItemIcon>
            <ListItemText primary={buttonNames.DOCUMENT_LIBRARY} />
          </ListItem>

          <ListItem
            button
            className={
              (`${classes.listItem}`,
              currentBranchesRecord === buttonNames.DOCUMENT_LIBRARY_FOR_BRANCH
                ? `${classes.selectedRecordItem}`
                : null)
            }
            onClick={() =>
              handleListItemClick(buttonNames.DOCUMENT_LIBRARY_FOR_BRANCH)
            }
          >
            <ListItemIcon>
              <AccountTree />
            </ListItemIcon>
            <ListItemText primary={buttonNames.DOCUMENT_LIBRARY_FOR_BRANCH} />
          </ListItem>

          <ListItem
            button
            className={
              (`${classes.listItem}`,
              currentBranchesRecord === buttonNames.USERS
                ? `${classes.selectedRecordItem}`
                : null)
            }
            onClick={() => handleListItemClick(buttonNames.USERS)}
          >
            <ListItemIcon>
              <UserIcon />
            </ListItemIcon>
            <ListItemText primary={buttonNames.USERS} />
          </ListItem>
        </List>
        <Divider />
      </Drawer>
      ;
    </React.Fragment>
  );
};

export default BranchRecordsItemsList;
